import { render, staticRenderFns } from "./CampusCard.vue?vue&type=template&id=bf98dd16&"
import script from "./CampusCard.vue?vue&type=script&lang=js&"
export * from "./CampusCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports